import $ from 'jquery';

document.addEventListener('DOMContentLoaded', function () {
    var header = $('.fixed--container');
    var adminBarHeight = $('#wpadminbar').outerHeight() || 0;
    var mobileMenuTrigger = $('.mobile-menu--trigger');
    var mobileMenu = $('.mobile-menu');
    var mobileMenuTriggerIconOpen = $('.mobile-menu--open');
    var mobileMenuTriggerIconClose = $('.mobile-menu--close');
    var navlink = $('.navlink');

    function getHeaderHeight() {
        var headerHeight = header.height();

        return headerHeight;
    }

    // Set initial height
    $('.header-bg-element-filler').height(getHeaderHeight());

    // Update height when window is resized
    $(window).on('resize', function() {
        $('.header-bg-element-filler').height(getHeaderHeight());
    });

    header.css({
        'top': adminBarHeight + 'px',
    });

    var lastScrollValue = 0;

    let scrollAmount = 50;
    
    // Hide header on initial load if scrolly is more than scrollAmount
    // After that the initial load the handleScroll function will take care of it
    if(window.scrollY > scrollAmount) {
        header.hide();
    } else {
        header.show();
    }



    let debounceTimer;

    function handleScroll() {
        var scroll = $(window).scrollTop();
    
        // Check if scroll position is greater than or equal to 120
        if (scroll >= scrollAmount) {
            header.removeClass('before-scroll').addClass('after-scroll');

            // Handle the visibility of the header
            if (scroll < lastScrollValue) {
                header.removeClass('hide-header').addClass('show-header');
            } else {
                header.removeClass('show-header').addClass('hide-header');
            }
    
            if (scroll === 0) {
                header.removeClass('hide-header').addClass('show-header');
            }
    
            lastScrollValue = scroll;
        } else {
            header.removeClass('after-scroll').addClass('before-scroll');
        }
    }
    
    

    mobileMenuTrigger.on('click', function() {
        header.toggleClass('mobile-menu-open');
        mobileMenu.slideToggle(300);
        mobileMenuTriggerIconOpen.toggle();
        mobileMenuTriggerIconClose.toggle();
        $('body').toggleClass('overflow-hidden');
    });

    navlink.on('click', function() {
        header.removeClass('mobile-menu-open');
        mobileMenu.slideUp(300);
        mobileMenuTriggerIconOpen.show();
        mobileMenuTriggerIconClose.hide();
        $('body').removeClass('overflow-hidden');
    });

    // On init
    mobileMenu.hide();
    handleScroll();

    // Event listener for scroll
    $(window).on('scroll', function () {
        handleScroll();
    });
});
